import {
  Form,
  Input,
  InputNumber,
  notification,
  Popconfirm,
  Table,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import {
  getApplicationParameters,
  putApplicationParameter,
} from '../../../store/requests/parameters';
import { useHistory } from 'react-router-dom';
import userHaveRolePermission from '../../../helpers/userHaveRolePermission';
import { PAGE_URLS } from '../../../helpers/endpoints';
import { useTranslation } from 'react-i18next';
import { STATUS } from '../../../helpers/constants';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const Parameters = ({ route }) => {
  const history = useHistory();
  const { isViewEnabled, isCrudEnabled } = userHaveRolePermission(route?.name);
  if (!isViewEnabled) {
    history.push(`${PAGE_URLS.AUTH}${PAGE_URLS.CONTROL}`);
  }
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const [distanceLimitData, setDistanceLimitData] = useState([]);
  const [editingKey, setEditingKey] = useState(null);
  const [loading, setLoading] = useState(false);
  const [putLoading, setPutLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      await getApplicationParameterKey();
    })();
  }, []);

  const getApplicationParameterKey = async (page = 0, size = 10) => {
    setLoading(true);
    const { content, page: paginationInfo } = await getApplicationParameters(
      `?filter=visible==true and scope.id==1&page=${page}&size=${size}&sort=id,asc`
    );
    const data = content.map((item) => ({
      key: Math.random().toString(36).substring(2) + Date.now().toString(36),
      ...item,
    }));
    setDistanceLimitData(data);
    setTotalItems(paginationInfo.totalElements);
    setCurrentPage(paginationInfo.number + 1);
    setLoading(false);
  };

  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey(null);
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const selectedItem = distanceLimitData.find((item) => key === item.key);
      const reqBody = {
        id: selectedItem.id,
        code: selectedItem.name,
        value: row.value,
        description: selectedItem.description,
        relationId: '',
        scope: 'default',
      };
      setPutLoading(true);
      putApplicationParameter(reqBody).then((res) => {
        if (res.status === 200) {
          notificationFn(STATUS.SUCCESS);
          setPutLoading(false);
          cancel();
          getApplicationParameterKey(currentPage - 1);
        }
      });
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const notificationFn = (type) => {
    notification[type]({
      message: t('processCompleted'),
      description: t('saveSuccessNotify'),
    });
  };

  const columns = [
    {
      title: t('bonusManagement.parameters'),
      dataIndex: 'description',
      width: '40%',
      editable: false,
    },
    {
      title: t('values'),
      dataIndex: 'value',
      width: '40%',
      editable: true,
    },
    {
      title: t('operations'),
      dataIndex: 'operation',
      width: '30%',
      render: (_, record) => {
        const editable = isEditing(record);
        return (
          <span>
            {editable ? (
              <>
                <Popconfirm
                  title={t('modalConfirm')}
                  okText={t('yes')}
                  cancelText={t('no')}
                  okButtonProps={{ loading: putLoading }}
                  onConfirm={() => save(record.key)}
                >
                  <a>{t('save')}</a>
                </Popconfirm>
                <Typography.Link
                  onClick={cancel}
                  style={{
                    marginLeft: 8,
                  }}
                  type="danger"
                >
                  {t('cancel')}
                </Typography.Link>
              </>
            ) : (
              <>
                {isCrudEnabled && (
                  <Typography.Link
                    disabled={editingKey !== null}
                    onClick={() => edit(record)}
                  >
                    {t('edit')}
                  </Typography.Link>
                )}
              </>
            )}
            <Typography.Link
              onClick={() => {
                history.push({
                  pathname: '/parametreler/parametre-detay',
                  state: { record },
                });
              }}
              style={{
                marginLeft: 30,
              }}
            >
              {t('detail')}
            </Typography.Link>
          </span>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        loading={loading}
        dataSource={distanceLimitData}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          current: currentPage, 
          pageSize: 10, 
          total: totalItems, 
          onChange: (page) => {
            setCurrentPage(page); 
            getApplicationParameterKey(page - 1);
          },
        }}
      />
    </Form>
  );
};
export default Parameters;
